
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useCallback } from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import Script from 'next/script';
import device from 'utils/device';
import Header from 'components/Header';
import Meta from 'components/Meta';
import HelpItem from 'components/HelpItem';
import Footer from 'components/Footer';
export default function Page() {
    const { t } = useTranslation('common');
    const handleChat = useCallback(() => {
        typeof window.Tawk_API !== 'undefined' && window.Tawk_API.toggle();
    }, []);
    return (<>
            <Meta title={t('help_name')}/>
            <Script id="tawk" strategy="lazyOnload">
                {`var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
                (function(){
                var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                s1.async=true;
                s1.src='https://embed.tawk.to/62d7ebba7b967b11799a7ac4/1g8dn1kfi';
                s1.charset='UTF-8';
                s1.setAttribute('crossorigin','*');
                s0.parentNode.insertBefore(s1,s0);
                })();`}
            </Script>
            <Full>
                <Top>
                    <Header />
                    <Help>
                        <Head>
                            <h1 className="h2">{t('help_name')}</h1>
                            <p>{t('help_description')}</p>
                        </Head>
                        <HelpItems>
                            <HelpItem nr="1" href="/help" name={t('help_block_1_name')} description={t('help_block_1_description')}/>
                            <HelpItem nr="2" href="/contact" name={t('help_block_2_name')} description={t('help_block_2_description')}/>
                            <HelpItem nr="3" onClick={handleChat} name={t('help_block_3_name')} description={t('help_block_4_description')}/>
                        </HelpItems>
                    </Help>
                    <CircleBig />
                    <CircleSmall />
                    <BottomCircleBig />
                    <BottomCircleSmall />
                </Top>
                <Footer />
            </Full>
        </>);
}
const Full = styled.div `
    min-height: 100vh;
    width: var(--wrap);
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    ${device.mobile} {
        width: var(--wrap-mobile);
        h1 {
            padding: 0 5%;
        }
    }
`;
const Top = styled.div `
    padding-bottom: 1.6rem;
    flex-grow: 1;
    position: relative;
    ${device.mobile} {
        padding-bottom: 0.64rem;
    }
`;
const Help = styled.div `
    position: relative;
    z-index: 2;
    width: var(--wrap)
    padding-top: 0.44rem;
    margin: 0 auto;
    ${device.mobile} {
        width: auto;
    }
`;
const Head = styled.div `
    text-align: center;
    p {
        max-width: 5.88rem;
        margin: 0 auto 0.36rem auto;
    }
`;
const CircleBig = styled.div `
    width: 2rem;
    height: 2rem;
    background: var(--color-orange);
    border-radius: 50%;
    position: absolute;
    right: 0;
    bottom: 0;
    margin-right: -0.82rem;
    ${device.mobile} {
        width: 1.35rem;
        height: 1.35rem;
        margin-right: -0.16rem;
    }
`;
const CircleSmall = styled.div `
    width: 0.8rem;
    height: 0.8rem;
    background: var(--color-green);
    border-radius: 50%;
    position: absolute;
    right: 1.86rem;
    bottom: 0;
    margin-right: -0.82rem;
    ${device.mobile} {
        width: 0.54rem;
        height: 0.54rem;
        margin-right: -0.16rem;
        right: 1.26rem;
    }
`;
const BottomCircleBig = styled.div `
    width: 3.8rem;
    height: 3.8rem;
    background: var(--color-purple);
    border-radius: 50%;
    position: absolute;
    left: 0;
    bottom: 0;
    margin-left: -0.82rem;
    ${device.mobile} {
        display: none;
    }
`;
const BottomCircleSmall = styled.div `
    width: 0.6rem;
    height: 0.6rem;
    background: var(--color-green);
    border-radius: 50%;
    position: absolute;
    left: 3.11rem;
    bottom: 0;
    margin-left: -0.82rem;
    ${device.mobile} {
        display: none;
    }
`;
const HelpItems = styled.div `
    display: flex;
    width: 100%;
    justify-content: space-between;
    ${device.mobile} {
        flex-direction: column;
    }
`;

    async function __Next_Translate__getStaticProps__19639cc49da__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/help',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19639cc49da__ as getStaticProps }
  